const statusMap = {
  candidate_placed: {
    id: 'candidate_placed',
    message: 'This candidate accepted an offer from another company.',
  },
  match_closed: {
    id: 'match_closed',
    message: 'This message was automatically archived.',
  },
  default: {
    id: 'default',
    message: 'This candidate is no longer available.',
  },
}

export const getUnavailableCandidateNotificationStatus = status =>
  statusMap[status] ? statusMap[status].message : statusMap.default.message
